export const companiesCompanyIdAiSettings = "/companies/:company_id/ai_settings";
